import React from "react";

export const Project = props => {
    const {
        project: { title, description, url }
    } = props;
    return (
        <div onClick={() => window.open(url, "_blank")}>
            <div>
                <h1>{title}</h1>
                <p>{description}</p>
            </div>
        </div>
    );
};
